export function convertToPutEventsRequest(event) {
  const {
    name,
    attributes,
    metrics,
    eventId,
    timestamp,
    endpointId,
    session
  } = event;
  const eventsRequest = {
    batchItem: {}
  };
  const endpointObj = {};
  endpointObj.endpoint = {};
  endpointObj.events = {
    [eventId]: {
      eventType: name,
      timestamp: new Date(timestamp).toISOString(),
      attributes,
      metrics,
      session
    }
  };
  eventsRequest.batchItem[endpointId] = endpointObj;
  return eventsRequest;
}

/**
 * <p>Specifies a batch of endpoints and events to process.</p>
 */

/**
 * <p>Specifies information about an event that reports data to Amazon Pinpoint.</p>
 */